// extracted by mini-css-extract-plugin
module.exports = {"roleBtn":"RoleBlock_roleBtn__3xTw6"};